import {useQuery} from "@apollo/client";
import {useContext, useState} from "react";
import {FiPlus} from "react-icons/fi";

import {ActionBarWrapper} from "@/components/actionBarWrapper/ActionBarWrapper.tsx";
import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {useDebouncedSearch} from "@/lib/hooks/useDebouncedSearch.ts";
import {GQL_STATUSPAGE_SYSTEM_METRICS, StatusPageSystemMetricsListResponse} from "@/lib/queries/statuspages.ts";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";
import {StatusPageSystemMetricUpdateModal} from "@/pages/statuspages/tabs/systemMetrics/systemMetricModal/StatusPageSystemMetricUpdateModal.tsx";
import {StatusPageSystemMetricsTableV2} from "@/pages/statuspages/tabs/systemMetrics/systemMetricsTable/StatusPageSystemMetricsTableV2.tsx";

export const StatusPageSystemMetricsTab = () => {
  const {statusPage} = useContext(StatusPageContext);
  const defaultSystemMetrics = statusPage.metrics;

  const [showMetricUpdateModal, setShowMetricUpdateModal] = useState(false);

  const {search, searchDebounced, searchChanged} = useDebouncedSearch();

  const {data, previousData} = useQuery<StatusPageSystemMetricsListResponse>(GQL_STATUSPAGE_SYSTEM_METRICS, {
    variables: {
      statusPageId: statusPage.id,
      search: searchDebounced,
    },
  });

  const renderData = data?.response || previousData?.response;

  if (!renderData) return <LoadingContainer text="Loading System Metrics…" />;

  const metricsData = searchDebounced
    ? {data: renderData.items, total: renderData.total}
    : {data: defaultSystemMetrics, total: (defaultSystemMetrics || []).length};

  return (
    <div className={"d-flex flex-column gap-3"}>
      <ActionBarWrapper
        left={
          <>
            <SearchInput value={search} onChange={searchChanged} variant={"tableControlBar"} />
          </>
        }
        right={
          <>
            <Button onClick={() => setShowMetricUpdateModal(true)} className={"text-nowrap"}>
              <Icon icon={FiPlus} />
              New System Metric
            </Button>
            <StatusPageSystemMetricUpdateModal
              show={showMetricUpdateModal}
              setShow={setShowMetricUpdateModal}
              statusPageID={statusPage.id}
              title="Create System Metric"
              submitBtnText="Create Metric"
            />
          </>
        }
      />
      <div>
        <StatusPageSystemMetricsTableV2
          data={metricsData}
          statusPageId={statusPage.id}
          isFiltered={!!searchDebounced}
        />
      </div>
    </div>
  );
};
